// client/src/components/learning/ModuleRenderer.tsx
import React from "react";
import PreLesson from "./PreLesson";
import MidLesson from "./MidLesson";
import MidLessonQuiz from "./MidLessonQuiz";
import SimulationModule from "./SimulationModule";
import PostLesson from "./PostLesson";
import InteractiveHeartModel from "./InteractiveHeartModel";
import { LessonSegment } from "../../types/learning";

interface ModuleRendererProps {
  module: LessonSegment;
  onComplete: (moduleId: string, data?: any) => void;
}

const ModuleRenderer: React.FC<ModuleRendererProps> = ({ module, onComplete }) => {
  // Use module.id if available; otherwise, fall back to module._id:
  const moduleId = module.id || (module as any)._id || "";
  
  switch (module.type) {
    case "pre":
      return <PreLesson onBegin={() => onComplete(moduleId)} />;
      
    case "mid":
      return (
        <MidLesson
          onComplete={(childModuleId: string, data?: any) =>
            onComplete(moduleId, data || {})
          }
        />
      );
      
    case "quiz":
      return (
        <MidLessonQuiz
          moduleData={module}
          onComplete={(childModuleId: string, data?: any) =>
            onComplete(moduleId, data || {})
          }
        />
      );
      
    case "simulation":
      return (
        <SimulationModule
          moduleData={module}
          onComplete={(childModuleId: string, data?: any) =>
            onComplete(moduleId, data || {})
          }
        />
      );

    case "heart-model":
      return (
        <InteractiveHeartModel />
      );
      
    case "post":
      return <PostLesson onFinish={() => onComplete(moduleId)} />;
      
    default:
      return <div>Unsupported module type: {module.type}</div>;
  }
};

export default ModuleRenderer;
